"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _Input = _interopRequireDefault(require("@material-ui/core/Input"));
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));
var _pickers = require("@material-ui/pickers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
class MTableFilterRow extends React.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "getLocalizationData", () => (0, _objectSpread2.default)({}, MTableFilterRow.defaultProps.localization, this.props.localization));
    (0, _defineProperty2.default)(this, "getLocalizedFilterPlaceHolder", columnDef => columnDef.filterPlaceholder || this.getLocalizationData().filterPlaceHolder || "");
    (0, _defineProperty2.default)(this, "LookupFilter", _ref => {
      let {
        columnDef
      } = _ref;
      const [selectedFilter, setSelectedFilter] = React.useState(columnDef.tableData.filterValue || []);
      React.useEffect(() => {
        setSelectedFilter(columnDef.tableData.filterValue || []);
      }, [columnDef.tableData.filterValue]);
      return /*#__PURE__*/React.createElement(_FormControl.default, {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(_InputLabel.default, {
        htmlFor: "select-multiple-checkbox" + columnDef.tableData.id,
        style: {
          marginTop: -16
        }
      }, this.getLocalizedFilterPlaceHolder(columnDef)), /*#__PURE__*/React.createElement(_Select.default, {
        multiple: true,
        value: selectedFilter,
        onClose: () => {
          if (columnDef.filterOnItemSelect !== true) this.props.onFilterChanged(columnDef.tableData.id, selectedFilter);
        },
        onChange: event => {
          setSelectedFilter(event.target.value);
          if (columnDef.filterOnItemSelect === true) this.props.onFilterChanged(columnDef.tableData.id, event.target.value);
        },
        input: /*#__PURE__*/React.createElement(_Input.default, {
          id: "select-multiple-checkbox" + columnDef.tableData.id
        }),
        renderValue: selecteds => selecteds.map(selected => columnDef.lookup[selected]).join(", "),
        MenuProps: MenuProps,
        style: {
          marginTop: 0
        }
      }, Object.keys(columnDef.lookup).map(key => /*#__PURE__*/React.createElement(_MenuItem.default, {
        key: key,
        value: key
      }, /*#__PURE__*/React.createElement(_Checkbox.default, {
        checked: selectedFilter.indexOf(key.toString()) > -1
      }), /*#__PURE__*/React.createElement(_ListItemText.default, {
        primary: columnDef.lookup[key]
      })))));
    });
    (0, _defineProperty2.default)(this, "renderFilterComponent", columnDef => React.createElement(columnDef.filterComponent, {
      columnDef: columnDef,
      onFilterChanged: this.props.onFilterChanged
    }));
    (0, _defineProperty2.default)(this, "renderBooleanFilter", columnDef => /*#__PURE__*/React.createElement(_Checkbox.default, {
      indeterminate: columnDef.tableData.filterValue === undefined,
      checked: columnDef.tableData.filterValue === "checked",
      onChange: () => {
        let val;
        if (columnDef.tableData.filterValue === undefined) {
          val = "checked";
        } else if (columnDef.tableData.filterValue === "checked") {
          val = "unchecked";
        }
        this.props.onFilterChanged(columnDef.tableData.id, val);
      }
    }));
    (0, _defineProperty2.default)(this, "renderDefaultFilter", columnDef => {
      const localization = this.getLocalizationData();
      const FilterIcon = this.props.icons.Filter;
      return /*#__PURE__*/React.createElement(_TextField.default, {
        style: columnDef.type === "numeric" ? {
          float: "right"
        } : {},
        type: columnDef.type === "numeric" ? "number" : "search",
        value: columnDef.tableData.filterValue || "",
        placeholder: this.getLocalizedFilterPlaceHolder(columnDef),
        onChange: event => {
          this.props.onFilterChanged(columnDef.tableData.id, event.target.value);
        },
        inputProps: {
          "aria-label": "filter data by ".concat(columnDef.title)
        },
        InputProps: this.props.hideFilterIcons || columnDef.hideFilterIcon ? undefined : {
          startAdornment: /*#__PURE__*/React.createElement(_InputAdornment.default, {
            position: "start"
          }, /*#__PURE__*/React.createElement(_Tooltip.default, {
            title: localization.filterTooltip
          }, /*#__PURE__*/React.createElement(FilterIcon, null)))
        }
      });
    });
    (0, _defineProperty2.default)(this, "renderDateTypeFilter", columnDef => {
      const onDateInputChange = date => this.props.onFilterChanged(columnDef.tableData.id, date);
      const pickerProps = {
        value: columnDef.tableData.filterValue || null,
        onChange: onDateInputChange,
        placeholder: this.getLocalizedFilterPlaceHolder(columnDef),
        clearable: true
      };
      let dateInputElement = null;
      if (columnDef.type === "date") {
        dateInputElement = /*#__PURE__*/React.createElement(_pickers.DatePicker, pickerProps);
      } else if (columnDef.type === "datetime") {
        dateInputElement = /*#__PURE__*/React.createElement(_pickers.DateTimePicker, pickerProps);
      } else if (columnDef.type === "time") {
        dateInputElement = /*#__PURE__*/React.createElement(_pickers.TimePicker, pickerProps);
      }
      return /*#__PURE__*/React.createElement(_pickers.MuiPickersUtilsProvider, {
        utils: _dateFns.default,
        locale: this.props.localization.dateTimePickerLocalization
      }, dateInputElement);
    });
  }
  getComponentForColumn(columnDef) {
    if (columnDef.filtering === false) {
      return null;
    }
    if (columnDef.field || columnDef.customFilterAndSearch) {
      if (columnDef.filterComponent) {
        return this.renderFilterComponent(columnDef);
      } else if (columnDef.lookup) {
        return /*#__PURE__*/React.createElement(this.LookupFilter, {
          columnDef: columnDef
        });
      } else if (columnDef.type === "boolean") {
        return this.renderBooleanFilter(columnDef);
      } else if (["date", "datetime", "time"].includes(columnDef.type)) {
        return this.renderDateTypeFilter(columnDef);
      } else {
        return this.renderDefaultFilter(columnDef);
      }
    }
  }
  render() {
    const columns = this.props.columns.filter(columnDef => !columnDef.hidden && !(columnDef.tableData.groupOrder > -1)).sort((a, b) => a.tableData.columnOrder - b.tableData.columnOrder).map(columnDef => /*#__PURE__*/React.createElement(_TableCell.default, {
      key: columnDef.tableData.id,
      style: (0, _objectSpread2.default)({}, this.props.filterCellStyle, columnDef.filterCellStyle)
    }, this.getComponentForColumn(columnDef)));
    if (this.props.selection) {
      columns.splice(0, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "none",
        key: "key-selection-column"
      }));
    }
    if (this.props.hasActions) {
      if (this.props.actionsColumnIndex === -1) {
        columns.push( /*#__PURE__*/React.createElement(_TableCell.default, {
          key: "key-action-column"
        }));
      } else {
        let endPos = 0;
        if (this.props.selection) {
          endPos = 1;
        }
        columns.splice(this.props.actionsColumnIndex + endPos, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
          key: "key-action-column"
        }));
      }
    }
    if (this.props.hasDetailPanel) {
      const alignment = this.props.detailPanelColumnAlignment;
      const index = alignment === "left" ? 0 : columns.length;
      columns.splice(index, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "none",
        key: "key-detail-panel-column"
      }));
    }
    if (this.props.isTreeData > 0) {
      columns.splice(0, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "none",
        key: "key-tree-data-filter"
      }));
    }
    this.props.columns.filter(columnDef => columnDef.tableData.groupOrder > -1).forEach(columnDef => {
      columns.splice(0, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "checkbox",
        key: "key-group-filter" + columnDef.tableData.id
      }));
    });
    return /*#__PURE__*/React.createElement(_TableRow.default, {
      style: (0, _objectSpread2.default)({
        height: 10
      }, this.props.filterRowStyle)
    }, columns);
  }
}
MTableFilterRow.defaultProps = {
  columns: [],
  detailPanelColumnAlignment: "left",
  selection: false,
  hasActions: false,
  localization: {
    filterTooltip: "Filter"
  },
  hideFilterIcons: false
};
MTableFilterRow.propTypes = {
  columns: _propTypes.default.array.isRequired,
  hasDetailPanel: _propTypes.default.bool.isRequired,
  detailPanelColumnAlignment: _propTypes.default.string,
  isTreeData: _propTypes.default.bool.isRequired,
  onFilterChanged: _propTypes.default.func.isRequired,
  filterCellStyle: _propTypes.default.object,
  filterRowStyle: _propTypes.default.object,
  selection: _propTypes.default.bool.isRequired,
  actionsColumnIndex: _propTypes.default.number,
  hasActions: _propTypes.default.bool,
  localization: _propTypes.default.object,
  hideFilterIcons: _propTypes.default.bool
};
var _default = exports.default = MTableFilterRow;